import { getMuiTheme } from "material-ui/styles"

const colorMain1 = 'rgb(161,200,84)'
const colorMain2 = 'rgb(238,141,35)'//'rgb(100,194,203)'
const colorMain3 = 'rgb(179,179,179)'
const colorSecondary1 = 'rgb(29,159,173)'//'rgb(62,183,131)'
const colorSecondary2 = 'rgb(237,237,237)'
const colorError = 'rgb(244, 67, 54)'

const theme = getMuiTheme({
  palette: {
    primary1Color: colorSecondary1,
    primary2Color: colorMain1,
    primary3Color: colorMain3,
    accent1Color: colorMain2,
  }
})

export { colorMain1, colorMain2, colorMain3, colorSecondary1, colorSecondary2, colorError }
export default theme



// WEBPACK FOOTER //
// ./src/lib/theme.js